import { inject, Injectable, signal } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs';

export interface PageTitleAction {
  label: string;
  icon: string;
  onClick: () => void;
}

@Injectable({
  providedIn: 'root',
})
export class PageTitleService {
  private readonly router = inject(Router);
  private readonly titleSignal = signal<string>('');
  private readonly subtitleSignal = signal<string>('');
  private readonly actionSignal = signal<PageTitleAction | null>(null);

  readonly title = this.titleSignal.asReadonly();
  readonly subtitle = this.subtitleSignal.asReadonly();
  readonly action = this.actionSignal.asReadonly();

  constructor() {
    this.router.events
      .pipe(filter((event): event is NavigationStart => event instanceof NavigationStart))
      .subscribe(() => {
        this.titleSignal.set('');
        this.subtitleSignal.set('');
        this.actionSignal.set(null);
      });
  }

  set(title: string, subtitle = ''): void {
    this.titleSignal.set(title);
    this.subtitleSignal.set(subtitle);
  }

  setAction(action: PageTitleAction | null): void {
    this.actionSignal.set(action);
  }
}
